export default __webpack_public_path__ + "static/media/Comprehensive_services_01.189945ba.png";